export enum ActivityDialogTypeEnum {
  ACCOUNT = 'account',
  LEAD_DRAFT = 'leadDraft'
}
